module.exports = __webpack_public_path__ + "0c505d0c1f4cd60c7b6f74b2c101da1d.svg";